import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';
import { PaginatedCollection } from '../app/models/PaginatedCollection';
import {
  ShipmentSmsEngagement,
  ShipmentSmsQueryParams,
  ShipmentSmsSummary
} from '../app/models/shipment-sms';

/**
 * The SMS channel's own numbers, read across every tenant.
 *
 * Deliberately tenant-less: the question is whether the channel is earning its cost, which no
 * single practice's view can answer.
 */
@Injectable({
  providedIn: 'root'
})
export class ShipmentSmsService {
  private readonly smsUrl = `${environment.api.baseUrl}${environment.api.endpoints.shipments}/sms`;

  constructor(private http: HttpClient) {}

  getEngagement(params: ShipmentSmsQueryParams): Observable<PaginatedCollection<ShipmentSmsEngagement>> {
    const query = new URLSearchParams();
    query.set('page', String(params.page ?? 0));
    query.set('size', String(params.size ?? 25));
    // Newest first: the interesting row is almost always the most recent one.
    query.set('sort', 'createdAt,desc');

    if (params.status) {
      query.set('status', params.status);
    }
    if (params.joinRequested) {
      query.set('joinRequested', 'true');
    }
    if (params.emailOverridden) {
      query.set('emailOverridden', 'true');
    }

    return this.http.get<PaginatedCollection<ShipmentSmsEngagement>>(
      `${this.smsUrl}?${query.toString()}`);
  }

  getSummary(): Observable<ShipmentSmsSummary> {
    return this.http.get<ShipmentSmsSummary>(`${this.smsUrl}/summary`);
  }
}
